import { MET_FIN_BY_COST_ITEM, MET_FIN_INDICATORS_ITEM, MET_FIN_OBLIGATIONS_ITEM } from './met-fin-items.js'

/** @type {import('../help-index.js').HelpScreen} */
export const MET_FIN_HELP = {
  screenId: 'met-fin',
  label: 'Finanzas',
  navPath: 'Métricas → Finanzas',
  keywords: ['flujo de caja', 'flujo de fondos', 'indicadores financieros', 'compromisos', 'vencimientos', 'cheques', 'kpi', 'liquidez', 'dso', 'dpo'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Flujo de fondos, indicadores financieros y compromisos de tesorería.',
  sidebarItems: [MET_FIN_BY_COST_ITEM, MET_FIN_INDICATORS_ITEM, MET_FIN_OBLIGATIONS_ITEM],
}
